import React from 'react';
import { FaWhatsapp, FaInstagram, FaFacebook, FaTiktok, FaPhone, FaClock, FaMapMarkerAlt } from 'react-icons/fa';
import { SOCIAL_LINKS, WHATSAPP_GENERAL_LINK } from '../data/products';

const Contact = () => {
    return (
        <section id="contacto" className="py-20 md:py-28 relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-dulce-pink-500 via-dulce-rose-500 to-dulce-pink-600" />
            <div className="absolute inset-0 opacity-10">
                <div className="absolute top-10 left-10 text-8xl">🧁</div>
                <div className="absolute bottom-10 right-10 text-8xl">🎂</div>
            </div>

            <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="animate-on-scroll">
                    <div className="text-center mb-12">
                        <span className="inline-block text-white/70 text-sm font-semibold tracking-widest uppercase mb-3">
                            📱 Contacto 📱
                        </span>
                        <h2 className="text-4xl md:text-5xl font-playfair font-bold text-white mb-4">
                            ¡Haz tu Pedido!
                        </h2>
                        <p className="font-dancing text-2xl text-white/90">Fácil, rápido y delicioso 💕</p>
                    </div>

                    <div className="grid md:grid-cols-2 gap-8">
                        <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 border border-white/20 text-center">
                            <div className="w-20 h-20 mx-auto mb-6 bg-green-500 rounded-full flex items-center justify-center shadow-2xl animate-pulse-soft">
                                <FaWhatsapp size={40} className="text-white" />
                            </div>
                            <h3 className="text-white text-2xl font-bold mb-2">Pedidos por WhatsApp</h3>
                            <p className="text-white/90 text-3xl font-bold mb-4 font-dancing">+569 93396909</p>
                            <p className="text-white/70 text-sm mb-6">
                                Escríbenos y te respondemos rápidamente.<br />
                                ¡Hacemos tu pedido con mucho amor! 💕
                            </p>
                            <a href={WHATSAPP_GENERAL_LINK} target="_blank" rel="noopener noreferrer"
                                className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white font-bold py-4 px-8 rounded-full shadow-2xl transform hover:scale-105 transition-all text-lg">
                                <FaWhatsapp size={24} />
                                <span>¡Pedir Ahora!</span>
                            </a>
                        </div>

                        <div className="space-y-6">
                            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
                                <h4 className="text-white font-bold text-lg mb-4">Información</h4>
                                <div className="space-y-4">
                                    <div className="flex items-center gap-3">
                                        <FaPhone className="text-green-400" size={18} />
                                        <div>
                                            <p className="text-white font-medium">+569 93396909</p>
                                            <p className="text-white/60 text-xs">WhatsApp</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <FaClock className="text-amber-300" size={18} />
                                        <div>
                                            <p className="text-white font-medium">Pedidos con 24 hrs de anticipación</p>
                                            <p className="text-white/60 text-xs">Para asegurar la mejor calidad</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <FaMapMarkerAlt className="text-red-300" size={18} />
                                        <div>
                                            <p className="text-white font-medium">Chile</p>
                                            <p className="text-white/60 text-xs">Consulta disponibilidad</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
                                <h4 className="text-white font-bold text-lg mb-4">Síguenos en Redes</h4>
                                <div className="grid grid-cols-3 gap-4">
                                    <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer"
                                        className="flex flex-col items-center gap-2 bg-white/10 hover:bg-white/20 rounded-xl p-4 transition-all hover:scale-105">
                                        <div className="bg-gradient-to-br from-purple-500 via-pink-500 to-orange-400 p-2.5 rounded-xl">
                                            <FaInstagram className="text-white" size={22} />
                                        </div>
                                        <span className="text-white/80 text-xs font-medium">Instagram</span>
                                    </a>
                                    <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noopener noreferrer"
                                        className="flex flex-col items-center gap-2 bg-white/10 hover:bg-white/20 rounded-xl p-4 transition-all hover:scale-105">
                                        <div className="bg-blue-600 p-2.5 rounded-xl">
                                            <FaFacebook className="text-white" size={22} />
                                        </div>
                                        <span className="text-white/80 text-xs font-medium">Facebook</span>
                                    </a>
                                    <a href={SOCIAL_LINKS.tiktok} target="_blank" rel="noopener noreferrer"
                                        className="flex flex-col items-center gap-2 bg-white/10 hover:bg-white/20 rounded-xl p-4 transition-all hover:scale-105">
                                        <div className="bg-black p-2.5 rounded-xl">
                                            <FaTiktok className="text-white" size={22} />
                                        </div>
                                        <span className="text-white/80 text-xs font-medium">TikTok</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;